/*
 * Welcome lines for the system message posted when someone joins a community.
 * The message content stores the line with a {user} placeholder, so clients
 * render the member's current name (bold and clickable) in its place.
 */

export const JOIN_PLACEHOLDER = "{user}";

export const JOIN_MESSAGES = [
  "Welcome, {user}. Say hi!",
  "{user} just showed up. Make some room.",
  "{user} is here. The party can start now.",
  "Good to see you, {user}. Pull up a chair.",
  "{user} hopped into the community.",
  "A wild {user} appeared.",
  "{user} just landed. Everyone wave!",
  "Everyone welcome {user}!",
  "{user} joined. Hope you brought snacks.",
  "Glad you're here, {user}.",
  "{user} just slid in. Act natural.",
  "Hello there, {user}!",
  "{user} has arrived. Let the fun begin.",
  "{user} walked in. Somebody put the kettle on.",
] as const;

export const randomJoinMessage = () => JOIN_MESSAGES[Math.floor(Math.random() * JOIN_MESSAGES.length)];

/** A system message is a join log when its content carries the placeholder. */
export const isJoinMessage = (m: { kind?: string | null; content: string }) => m.kind === "system" && m.content.includes(JOIN_PLACEHOLDER);

/** Splits a join line around the placeholder: [before, after]. */
export function splitJoinMessage(content: string): [string, string] {
  const i = content.indexOf(JOIN_PLACEHOLDER);
  return i < 0 ? [content, ""] : [content.slice(0, i), content.slice(i + JOIN_PLACEHOLDER.length)];
}
